import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import CardService from '../services/CardService';
import InputTextComponent from '../components/inputs/InputTextComponent';

class SelectCustomerDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            selectedCustomer: undefined,
        };
        this.renderFooter = this.renderFooter.bind(this);
    }
    getContainerListName() {
        return 'user-card-list-container';
    }

    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    label={t('list.select')}
                    variant='button save-button fullred'
                    handleClick={this.handleFormSubmit}
                    disabled={this.state.selectedCustomer === undefined}
                />
            </div>
        );
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                    <DivContainer colClass='col-12'>
                        <label id={`auth-dialog-header-label-id`}>{`${t('autoRegistration.selectCustomerHeader')}`}</label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    createOrUpdate() {
        if (this.props.handleSuccess) {
            this.props.handleSuccess(this.state.selectedCustomer);
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <div className='customers-container'>
                <DivContainer colClass=''>
                    <span>{t('autoRegistration.customerSelectInfo')}</span>
                </DivContainer>
                <DivContainer colClass='back-off-row'>
                    <div className='row card-type-buttons'>
                        {this.props.customerOptions.map((customer, index) => {
                            return (
                                <div className='width-auto' key={`customer-${index}`}>
                                    <ActionButton
                                        key={`customer-${index}`}
                                        id={`customer-${index}`}
                                        variant={
                                            this.state.selectedCustomer === customer
                                                ? 'button white-pressed card-type'
                                                : 'button white-black card-type'
                                        }
                                        colClass='col-sm-12 col-md-6'
                                        inputLikeStyle={false}
                                        label={
                                            <div className='row'>
                                                <InputTextComponent
                                                    id='companyName'
                                                    name='companyName'
                                                    label={t('profile.companyName')}
                                                    colClass='col-12'
                                                    value={customer.fullName}
                                                    viewMode={'VIEW'}
                                                    validator={this.validator}
                                                    validators='required'
                                                    onChange={this.handleChange}
                                                />
                                                <InputTextComponent
                                                    id='companyRegon'
                                                    name='companyRegon'
                                                    label={t('profile.regon')}
                                                    colClass='col-12'
                                                    value={customer.regon}
                                                    viewMode={'VIEW'}
                                                    validator={this.validator}
                                                    validators='required'
                                                    onChange={this.handleChange}
                                                />
                                                <InputTextComponent
                                                    id='companyAddress'
                                                    name='companyAddress'
                                                    label={t('autoRegistration.address')}
                                                    colClass='col-12'
                                                    value={!customer.fullAddress.street && !customer.fullAddress.city && !customer.fullAddress.streetNumber && !customer.fullAddress.postCode ? '-' :  `${
                                                        customer.fullAddress.street
                                                            ? customer.fullAddress.street ?? ''
                                                            : customer.fullAddress.city ?? ''
                                                    } ${
                                                        customer.fullAddress.flatNumber
                                                            ? `${customer.fullAddress.streetNumber ?? ''}/${customer.fullAddress.flatNumber ?? ''}`
                                                            : customer.fullAddress.streetNumber ?? ''
                                                    } ${
                                                        customer.fullAddress.postCode ?? ''} ${customer.fullAddress.city ?? ''
                                                    } ${
                                                        customer.fullAddress.provinceId ? `woj. ${this.props.provinceOptions.find(el => el.petraId === customer.fullAddress.provinceId)?.name?.toUpperCase() ?? ''}` : ''
                                                    }`}
                                                    viewMode={'VIEW'}
                                                    validator={this.validator}
                                                    validators='required'
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        }
                                        showDescription={true}
                                        descriptionClassName='card-type-description'
                                        handleClick={() => this.setState({selectedCustomer: customer})}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </DivContainer>
            </div>
        );
    }
}

SelectCustomerDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    cardNumber: '',
};

SelectCustomerDialog.propTypes = {
    currentUser: PropTypes.object,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    customerOptions: PropTypes.array,
    provinceOptions: PropTypes.array,
};

export default withTranslation()(SelectCustomerDialog);
